<template>
  <div class="print">
    <!-- 1. 헤더 및 결재란 -->
    <section class="section-approval">
      <div class="header-left-area">
        <p class="print-title">{{ $t('반기별 보고') }}</p>
        <div class="division-title mt-10">□ {{ $t('기본정보') }}</div>
      </div>

      <table class="table-approval-field mt-auto">
        <colgroup>
          <col width="38" />
          <col width="112" />
          <col width="112" />
          <col width="112" />
          <col width="112" />
        </colgroup>
        <tr>
          <th rowspan="2" class="gray p-0">
            <div class="flex justify-center items-center">
              <p style="writing-mode: vertical-lr">{{ $i18n.locale === 'ko' ? $t('결&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;재') : $t('결재') }}</p>
            </div>
          </th>
          <th class="gray">{{ $t('작성자') }}</th>
          <th class="gray">{{ $t('검토자') }}</th>
          <th class="gray">{{ $t('회람자') }}</th>
          <th class="gray">{{ $t('승인자') }}</th>
        </tr>
        <tr>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign1.sign" :src="form.sign1.sign" class="signature-image" />
              <p v-else-if="form.sign1.name" class="name-text">{{ form.sign1.name }}</p>
            </div>
          </td>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign2.sign" :src="form.sign2.sign" class="signature-image" />
              <p v-else-if="form.sign2.name" class="name-text">{{ form.sign2.name }}</p>
            </div>
          </td>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign3.sign" :src="form.sign3.sign" class="signature-image" />
              <p v-else-if="form.sign3.name" class="name-text">{{ form.sign3.name }}</p>
            </div>
          </td>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign4.sign" :src="form.sign4.sign" class="signature-image" />
              <p v-else-if="form.sign4.name" class="name-text">{{ form.sign4.name }}</p>
            </div>
          </td>
        </tr>
      </table>
    </section>

    <!-- 2. 기본 정보 -->
    <section class="section-stdInfo mb-5">
      <table class="w-full">
        <colgroup>
          <col width="140" />
          <col />
          <col width="140" />
          <col />
        </colgroup>
        <tr>
          <th>{{ $t('학교명') }}</th>
          <td>
            <div class="text-left px-2">{{ form.stdInfo.field_name || "-" }}</div>
          </td>
          <th>{{ $t('작성자') }}</th>
          <td>
            <div class="text-left px-2">{{ form.stdInfo.writer_name || "-" }}</div>
          </td>
        </tr>
        <tr>
          <th>{{ $t('작성일') }}</th>
          <td>
            <div class="text-left px-2">{{ form.stdInfo.date || "-" }}</div>
          </td>
          <th>{{ $t('점검일') }}</th>
          <td>
            <div class="text-left px-2">{{ form.stdInfo.점검일 || "-" }}</div>
          </td>
        </tr>
        <tr>
          <th>{{ $t('점검장소') }}</th>
          <td>
            <div class="text-left px-2">{{ form.stdInfo.점검장소 || "-" }}</div>
          </td>
          <th>{{ $t('재해형태') }}</th>
          <td>
            <div class="text-left px-2">{{ form.stdInfo.재해형태 || "-" }}</div>
          </td>
        </tr>
      </table>
    </section>

    <!-- 3. 점검 대상 단위사업장 -->
    <section class="section-workplace mb-5">
      <div class="division-title">□ {{ $t('점검 대상 단위사업장') }}</div>
      <table class="w-full">
        <colgroup>
          <col />
          <col width="150" />
          <col width="200" />
          <col width="200" />
        </colgroup>
        <thead>
          <tr>
            <th>{{ $t('단위사업장명') }}</th>
            <th>{{ $t('담당자') }}</th>
            <th>{{ $t('연락처') }}</th>
            <th>{{ $t('비고') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in form.pobList" :key="'pob_' + index">
            <td>{{ item.data1 || "-" }}</td>
            <td>{{ item.data2 || "-" }}</td>
            <td>{{ item.data3 || "-" }}</td>
            <td>{{ item.data4 || "-" }}</td>
          </tr>
          <tr v-if="!form.pobList || form.pobList.length === 0">
            <td colspan="4" class="py-4">{{ $t('데이터가 없습니다.') }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <!-- 4. 반기별 점검 -->
    <section class="section-inspection mb-5">
      <div class="division-title">□ {{ $t('반기별 점검') }}</div>
      <table class="w-full">
        <colgroup>
          <col />
          <col width="60" />
          <col width="60" />
          <col width="80" />
          <col width="250" />
        </colgroup>
        <thead>
          <tr>
            <th>{{ $t('자가진단 항목') }}</th>
            <th>{{ $t('양호') }}</th>
            <th>{{ $t('미흡') }}</th>
            <th>{{ $t('해당없음') }}</th>
            <th>{{ $t('비고(문제점)') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in form.inspectList" :key="'inspect_' + index">
            <td class="text-left py-2 px-4">• {{ $t(item.content) }}</td>
            <td>
              <PrintCheckbox :value="item.isChecked === '양호'" class="justify-center" />
            </td>
            <td>
              <PrintCheckbox :value="item.isChecked === '미흡'" class="justify-center" />
            </td>
            <td>
              <PrintCheckbox :value="item.isChecked === '해당없음'" class="justify-center" />
            </td>
            <td class="text-left">{{ item["비고(보완계획)"] || "-" }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <!-- 5. 사진대지 -->
    <section class="section-photo mb-5" v-if="form.photoList && form.photoList.length > 0">
      <div class="division-title">□ {{ $t('사진대지') }}</div>
      <div class="photo-grid">
        <div v-for="(photo, index) in form.photoList" :key="'photo_' + index" class="photo-item" v-if="photo.path">
          <div class="photo-box">
            <img :src="photo.path" class="grid-photo" />
          </div>
          <div class="photo-desc">{{ photo.input }}</div>
        </div>
      </div>
    </section>

    <!-- 6. 첨부파일 -->
    <section class="section-file mb-10" v-if="form.fileList && form.fileList.length > 0">
      <div class="division-title">□ {{ $t('첨부파일') }}</div>
      <table class="w-full">
        <colgroup>
          <col width="160" />
          <col />
        </colgroup>
        <tr v-for="(file, index) in form.fileList" :key="'file_' + index">
          <th>{{ $t('파일명') }}</th>
          <td class="text-left">{{ file.fileName }}</td>
        </tr>
      </table>
    </section>
  </div>
</template>

<script>
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  name: "Print134",
  components: { PrintCheckbox },
  props: {
    form: {
      type: Object,
      default: () => ({
        stdInfo: {},
        pobList: [],
        inspectList: [],
        photoList: [],
        sign1: { name: "", sign: "" },
        sign2: { name: "", sign: "" },
        sign3: { name: "", sign: "" },
        sign4: { name: "", sign: "" },
        fileList: [],
      }),
    },
  },
};
</script>

<style lang="scss" scoped>
.print {
  .signature-container {
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px;

    .signature-image {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 70px;
      object-fit: contain;
      display: block;
    }
    .name-text {
      font-size: 16px;
      margin-top: 5px;
    }
  }

  table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;

    th, td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 18px;
      padding: 10px;
      vertical-align: middle;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
      height: 60px;
    }
    td {
      word-break: break-all;
    }
    .gray {
      background-color: #ececec;
    }
    .text-left {
      text-align: left;
      padding: 10px 14px;
      word-break: break-word;
    }
  }

  .section-approval {
    display: grid;
    grid-template-columns: 1fr auto;
    width: 100%;
    align-items: flex-start;

    .header-left-area {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      padding-top: 20px;

      .print-title {
        font-size: 32px;
        font-weight: bold;
        color: #000;
        text-align: center;
        margin-bottom: 20px;
      }
    }

    .table-approval-field {
      width: auto;
      margin-left: 10px;
      tr:last-child { th, td { border-bottom: 1px solid #757575; } }
    }
  }

  .division-title {
    font-size: 24px;
    font-weight: bold;
    color: #3C3C3C;
    padding: 1.25rem 0rem;
  }

  .photo-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    width: 100%;
  }
  .photo-item {
    border: 1px solid #757575;
    display: flex;
    flex-direction: column;
  }
  .photo-box {
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #757575;
    padding: 10px;
    background: #f9f9f9;

    .grid-photo {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
  .photo-desc {
    padding: 10px;
    font-size: 16px;
    min-height: 54px;
    text-align: left;
    background: #fff;
  }
}

@media print {
  section {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  .photo-item {
    page-break-inside: avoid;
  }
}
</style>
